import { LatLng, LatLngBounds } from 'leaflet';
import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import PropTypes from 'prop-types';

const AdjustMapView = ({ locations }) => {
  const map = useMap();

  useEffect(() => {
    if (locations.length > 0) {
      const latLngs = locations.map((loc) => new LatLng(loc.latitude, loc.longitude));
      const bounds = new LatLngBounds(latLngs);
      map.fitBounds(bounds);
    }
  }, [locations, map]);

  return null;
};

AdjustMapView.propTypes = {
  locations: PropTypes.array.isRequired,
};

export default AdjustMapView;
